<template>
  <v-card fill-height fluid>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items touchless v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        <component :is="item.dist" :title="item.tab" :url="item.url" />
      </v-tab-item>
    </v-tabs-items>

  </v-card>
</template>

<script>

  export default {

    components: {
      MainReports: () => import('@/components/bi/MainReports'),
      FinanceReports: () => import('@/components/bi/FinanceReports.vue'),
      Cohorts: () => import('@/modules/bi-cohorts').then(module => module.BiCohortsContainer)
    },

    data: () => ({
      tab: null,
      items: [
        { tab: 'Dashboard', dist: 'MainReports' },
        { tab: 'Finance', dist: 'FinanceReports' },
        { tab: 'Cohort analysis', dist: 'Cohorts', access: 'cohorts' }
      ]
    }),

    mounted () {
    },

    methods: {},
  }
</script>
